import { Mutation } from 'types/graphql';
import { TEventContextProviderProps } from 'components/context/EventContext/interfaces';

export interface CreateSectionModalProps extends UnknownProps, AddSectionProps {
  eventContext: TEventContextProviderProps;
}

export interface AddSectionProps {
  createSectionMutation: Mutation;
  variables: UnknownProps;
  eventSettings?: EventSettings;
  insertBeforeSectionId?: Nullable<string>;
  refetchQueries?: string[];
}

export enum SectionCreateKey {
  newSection = 'newSection',
  fromFavorites = 'fromFavorites',
}
